module.exports = __webpack_public_path__ + "img/p32.bc8a1fc2.jpg";